import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import getCategoryColorsForCategory, {
    getDefaultCategoryColor,
} from '../utils/getCategoryColorsForCategory';
import { ControlIcons } from 'owa-control-icons';
import categoryStore from '../store/store';
import * as React from 'react';
import { CategoryType, getMasterCategoryList } from 'owa-categories';

const styles = require('../scss/CategorySharedStyles.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CategoryIconProps {
    categoryName?: string;
    categoryList?: CategoryType[];
    categoryColorId?: string;
    iconClassName: string;
}

const CategoryIcon = observer(function CategoryIcon(props: CategoryIconProps) {
    let categoryColor;

    /**
     * Try to get category color from the category name
     * If the name is not specified (in case of new category creation) check if color id is specified and get color from the colorValueMap
     * Else use the default color
     */
    if (props.categoryName) {
        categoryColor = getCategoryColorsForCategory(
            props.categoryName,
            props.categoryList ? props.categoryList : getMasterCategoryList()
        );
    } else if (props.categoryColorId) {
        categoryColor = categoryStore.colorCodeColorValueMap[props.categoryColorId];
    } else {
        categoryColor = getDefaultCategoryColor();
    }

    const iconStyles = { color: categoryColor.iconColor };
    const iconClass = classNames(styles.categoryIcon, props.iconClassName);

    return <Icon className={iconClass} iconName={ControlIcons.TagSolid} style={iconStyles} />;
});
export default CategoryIcon;
